import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CancelButton from '../../Button/CancelButton';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  submit: {
    display: 'flex',
    justifyContent: 'center',
  },
  submitButton: { position: 'relative' },
  cancelButton: { marginRight: theme.spacing(2) },
  loading: { position: 'absolute', right: theme.spacing(1) },
}));

export default function SubmitAndCancelButtons(props) {
  const classes = useStyles();
  const {
    submitForm,
    isSubmitting,
    text,
    handleClose,
    disabled = false,
  } = props;

  return (
    <>
      <CancelButton onCancel={handleClose} className={classes.cancelButton} />
      <Button
        onClick={submitForm}
        autoFocus
        color="primary"
        variant="contained"
        disabled={isSubmitting || disabled}
      >
        {text}
        {isSubmitting && (
          <CircularProgress className={classes.loading} size={28} />
        )}
      </Button>
    </>
  );
}
